var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("appointment-coordination", {
    attrs: {
      "coordinate-new-space": _vm.coordinateNewSpace,
      "get-appointment-info": _vm.getAppointmentInfo,
      "get-breach": _vm.getBreach,
      "get-centerby-user-id": _vm.getCenterbyUserId,
      "get-centers": _vm.getCenters,
      "get-contact-information": _vm.getContactInformation,
      "get-municipalities-by-discipline": _vm.getMunicipalitiesByDiscipline,
      "get-phone-providers": _vm.getPhoneProviders,
      "get-registration-date": _vm.getRegistrationDate,
      "get-relationships": _vm.getRelationships,
      "get-student-detail": _vm.getStudentDetail,
      "get-valid-appointment-disciplines": _vm.getValidAppointmentDisciplines,
      "has-active-coordinated-discipline-fn":
        _vm.hasActiveCoordinatedDisciplineFn,
      "has-permissions": _vm.hasPermissions,
      "load-validation-messages": _vm.loadValidationMessages,
      "save-appointment-coordinate": _vm.saveAppointmentCoordinate,
      "search-available-dates": _vm.searchAvailableDates,
      user: _vm.user
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }